import { useEffect, useRef } from 'react'
import type { ReactNode } from 'react'

/** Native modal supplies focus containment, Escape, and an inert background. */
export default function ShopDialog({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
    const ref = useRef<HTMLDialogElement>(null)
    useEffect(() => {
        const dialog = ref.current
        const previous = document.activeElement as HTMLElement | null
        const overflow = document.body.style.overflow
        dialog?.showModal()
        document.body.style.overflow = 'hidden'
        return () => {
            dialog?.close()
            document.body.style.overflow = overflow
            previous?.focus()
        }
    }, [])
    return <dialog ref={ref} className="shop-dialog" aria-label={title} onCancel={event => { event.preventDefault(); onClose() }} onClick={event => {
        if (event.target !== ref.current) return
        const bounds = ref.current.getBoundingClientRect()
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose()
    }}>
        <h2>{title}</h2>{children}
    </dialog>
}
